import { useTranslation } from 'react-i18next';
import { Button, Divider, Tag, Select, Affix } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import { useEffect } from 'react';
import parse from 'html-react-parser';
import IconEmpty from '../../../../assets/Images/icons/empty';
import DataFlowService from '../../../../services/DataFlow.service';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import { metaDataRender } from '../../../../util/tagRender';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab3 = ({
    referenceDocuments,
    editMode,
    metadataList,
    getDataFlowDetail,
    getMetadataList,
    isNoPermission,
    dataFlowInfo
}) => {
    const notify = useNotify();
    const { Option } = Select;
    let { businessProcessId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const itemEls = useRef([]);
    const [dataList, setDataList] = useState(referenceDocuments);
    const [openDelete, setOpenDelete] = useState(false);
    const [deletevalue, setDeleteValue] = useState();
    const [idxFocus, setIdxFocus] = useState();

    useEffect(() => {
        if (idxFocus != null) {
            itemEls.current[idxFocus].focus();
        }
    }, [idxFocus]);

    useEffect(() => {
        if (referenceDocuments) {
            setDataList(referenceDocuments);
        }
    }, [referenceDocuments]);

    const handleChange = async (e, referenceId) => {
        const lastValue = e[e.length - 1];
        const metadata = await metadataList.find((m) => m.value === lastValue);
        if (lastValue) {
            if (metadata) {
                const payload = {
                    referenceId: referenceId,
                    metadataId: metadata.id,
                };
                updateMappingMetadata(payload);
            } else {
                const payload = {
                    referenceId: referenceId,
                    metadataName: lastValue,
                };
                createMetadata(payload);
            }
        }
    };

    const updateMappingMetadata = async (payload) => {
        await DataFlowService.mappingMetadata(payload)
            .then((res) => {
                getDataFlowDetail();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createMetadata = async (payload) => {
        await DataFlowService.createMetadata(payload)
            .then((res) => {
                getDataFlowDetail();
                getMetadataList();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const onClose = (e, props, referenceId) => {
        e.preventDefault();
        setOpenDelete(true);
        const metadata = metadataList.find(
            (meta) => meta.value === props.value
        );
        if (metadata) {
            setDeleteValue({
                referenceId: referenceId,
                metadataId: metadata.id,
                metadataName: metadata.value,
            });
        }
    };

    const deleteMetadata = async () => {
        await DataFlowService.deleteMetadata(
            deletevalue.referenceId,
            deletevalue.metadataId
        )
            .then((res) => {
                setOpenDelete(false);
                getDataFlowDetail();
                getMetadataList();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                });
            })
            .catch((err) => {
                setOpenDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedDeleteData'),
                });
            });
    };

    return (
        <div className="grid grid-cols-2">
            <div className="col-span-2 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=3`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>

            {dataList?.length > 0 ? (
                <>
                    <div className="col-span-2 mb-2">
                        <span className="text-xl font-semibold">
                            {t('dataFlow.Reference')}
                        </span>
                    </div>
                    <div className="col-span-2 font-medium pb-4">
                        {parse(t('Dataflow Tab3'))}
                    </div>
                    {/* start referenceDocuments */}
                    {dataList.length > 0 && (
                        <div
                            className="col-span-2 mb-2"
                            style={{ backgroundColor: '#F4F6FC' }}
                        >
                            <div className="grid grid-cols-2 p-4">
                                <div className="col-span-1">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.ReferenceName')}
                                    </span>
                                </div>
                                <div className="col-span-1">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.Category')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-span-2 mb-2">
                        {dataList.length > 0 &&
                            dataList.map((item, index) => (
                                <>
                                    <div className="grid grid-cols-2 p-4 flex items-center justify-center">
                                        <div className="col-span-1 mb-2">
                                            <span
                                                className="font-large font-semibold"
                                                key={index}
                                            >
                                                {item?.name}
                                            </span>
                                            <p
                                                className="font-large font-base mt-2"
                                                key={index}
                                            >
                                                {item?.storagePeriod}
                                            </p>
                                            <p className="mt-2">
                                                {item.documentTypes.length >
                                                    0 &&
                                                    item.documentTypes.map(
                                                        (
                                                            documentType,
                                                            indexDocumentType
                                                        ) => (
                                                            <Tag
                                                                key={
                                                                    indexDocumentType
                                                                }
                                                                color="#1890FF"
                                                                style={{
                                                                    borderRadius:
                                                                        '10px',
                                                                }}
                                                            >
                                                                {
                                                                    documentType.name
                                                                }
                                                            </Tag>
                                                        )
                                                    )}
                                            </p>
                                        </div>
                                        <div className="col-span-1">
                                            {item.inputVisible ||
                                                item.metadata.length > 0 ? (
                                                <Select
                                                    disabled={!editMode}
                                                    size="large"
                                                    mode="tags"
                                                    className="meta"
                                                    ref={(element) =>
                                                    (itemEls.current[
                                                        index
                                                    ] = element)
                                                    }
                                                    style={{ width: '100%' }}
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    tagRender={(props) =>
                                                        metaDataRender({
                                                            ...props,
                                                            onClose: (e) =>
                                                                onClose(
                                                                    e,
                                                                    props,
                                                                    item.referenceDocumentId
                                                                ),
                                                            closable: editMode,
                                                        })
                                                    }
                                                    value={item.metadata?.map(
                                                        (meta) => meta.name
                                                    )}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            e,
                                                            item.referenceDocumentId
                                                        )
                                                    }
                                                    onBlur={() => {
                                                        item.inputVisible = false;
                                                        setDataList([
                                                            ...dataList,
                                                        ]);
                                                        setIdxFocus(null);
                                                    }}
                                                >
                                                    {metadataList?.map(
                                                        (meta) => (
                                                            <Option
                                                                key={meta.id}
                                                                value={
                                                                    meta.value
                                                                }
                                                            >
                                                                {meta.value}
                                                            </Option>
                                                        )
                                                    )}
                                                </Select>
                                            ) : (
                                                <Tag
                                                    color="processing"
                                                    className="meta-site-tag-plus pt-1 pb-1 pl-3 pr-3 ml-4 cursor-pointer"
                                                    hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                                                    onClick={() => {
                                                        item.inputVisible = true;
                                                        setDataList([
                                                            ...dataList,
                                                        ]);
                                                        setIdxFocus(index);
                                                    }}
                                                >
                                                    <PlusOutlined />{' '}
                                                    {t('dataFlow.AddMetadata')}
                                                </Tag>
                                            )}
                                        </div>
                                    </div>
                                    <Divider className="m-0" />
                                </>
                            ))}
                    </div>
                </>
            ) : (
                <div className="col-span-2 h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
            <ModalDelete
                open={openDelete}
                text={t('dataCorrelation.ConfirmedDelete', {
                    name: deletevalue?.metadataName,
                })}
                handelOk={() => {
                    deleteMetadata();
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </div>
    );
};
export default Tab3;
